module.exports = __webpack_public_path__ + "static/media/diamonds.7cbda470.webp";